module.exports = __webpack_public_path__ + "static/media/buildings-vector.23a63f1c.png";